import { Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { Store } from "@ngxs/store";
import { ViewState } from "@vattenfall/core";

import { FlowsFIRenewalLoginAction } from "./flows-fi-renewal-login.element.action";
import { FlowsFIRenewalLoginModel } from "./flows-fi-renewal-login.element.model";
import { PROPERTIES } from "./flows-fi-renewal-login.element.properties";
import { VIEWSTATES } from "./flows-fi-renewal-login.element.viewstates";

@Component({
  selector: "flows-fi-renewal-login",
  templateUrl: "./flows-fi-renewal-login.element.html",
  styleUrls: ["./flows-fi-renewal-login.element.scss"],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class FlowsFIRenewalLogin extends ViewState(FlowsFIRenewalLoginModel) implements OnInit {
  @Input("redirect-to-renewal-page-url") redirectToRenewalPageUrl!: string;

  fiLoginForm = this.fb.group({
    customerno: [null, [Validators.required, Validators.maxLength(7), Validators.pattern("^[0-9]{7}$")]],
    agreementno: [null, [Validators.required, Validators.maxLength(10), Validators.pattern("^[0-9]{10}$")]],
    redirectToRenewalPageUrl: "",
  });

  constructor(public store: Store, public elementRef: ElementRef, public renderer: Renderer2, private fb: FormBuilder) {
    super();
  }

  ngOnInit() {
    super.viewStateInit(
      PROPERTIES,
      {
        store: this.store,
        elementRef: this.elementRef,
        renderer: this.renderer,
      },
      VIEWSTATES
    );
    // Set the value of redirectToRenewalPageUrl in the form after component initialization
    this.fiLoginForm.patchValue({
      redirectToRenewalPageUrl: this.redirectToRenewalPageUrl,
    });
    this.store.dispatch(new FlowsFIRenewalLoginAction.Focused());
    const element = document.getElementById("flows-fi-renewal-login");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  }

  onSubmit() {
    this.store.dispatch(new FlowsFIRenewalLoginAction.Submit(this.fiLoginForm.value));
  }
}
